import { p as prisma } from "../../../../../../../chunks/prisma.js";
import { redirect, error } from "@sveltejs/kit";
const load = async ({ params, locals }) => {
  const productId = Number(params.id);
  const docId = Number(params.docId);
  if (!locals.user) throw redirect(303, "/login");
  const product = await prisma.product.findUnique({ where: { id: productId, isPublished: true } });
  if (!product) throw error(404, "Product not found");
  const pd = await prisma.productDocument.findFirst({
    where: { id: docId, productId, isPublished: true },
    select: { id: true, originalName: true, documentId: true, pageCount: true }
  });
  if (!pd) throw error(404, "Document not found");
  if (locals.isSubscribed) {
    return { productId, docId: pd.id, title: pd.originalName };
  }
  const lookupIds = [pd.documentId, pd.id].filter(Boolean);
  if (lookupIds.length > 0) {
    const now = /* @__PURE__ */ new Date();
    const ent = await prisma.entitlement.findFirst({
      where: {
        userId: locals.user.id,
        documentId: { in: lookupIds },
        OR: [{ expiresAt: null }, { expiresAt: { gt: now } }]
      },
      select: { id: true }
    });
    if (ent) {
      return { productId, docId: pd.id, title: pd.originalName };
    }
  }
  throw redirect(303, "/pricing");
};
export {
  load
};
